import {
  DOCUMENTS_TYPES,
  MAX_MEGABYTE,
  SUPPORTED_FORMATS,
} from '../FileUpload/FileUpload.constants';

export const EMPLOYMENT_TYPES = {
  INDIVIDUAL_ENTREPRENEUR_3: 'individual-entrepreneur-3',
  UNEMPLOYED_MILITARY_RETIRED: 'unemployedMilitaryRetired',
  UNEMPLOYED_RETIREE: 'unemployedRetiree',
  NOT_WORKING: 'not_working',
  UNEMPLOYMENT_TYPE_ANOTHER: 'employment-type-another',
};

export const CLASS_ORDER = [
  DOCUMENTS_TYPES.PASSPORT,
  DOCUMENTS_TYPES.DRIVER_LICENCE,
  DOCUMENTS_TYPES.SNILS,
  DOCUMENTS_TYPES.INTERNATIONAL_PASSPORT,
  DOCUMENTS_TYPES.INN,
  DOCUMENTS_TYPES.MILITARY_ID,
  DOCUMENTS_TYPES.JOB_INCOME_DOCUMENTS,
  DOCUMENTS_TYPES.PTS,
  DOCUMENTS_TYPES.CUSTOMER_FOTO,
  DOCUMENTS_TYPES.OTHER,
];

export const PERSONAL_INFO_TITLE_EXCEPTIONS_KEYS = {
  DRIVER_LICENSE: 'Водительское удостоверение',
  VEHICLE_PTS: 'ПТС приобретаемого автомобиля',
};

export const PERSONAL_INFO_SUB_TITLES = {
  UPLOAD_DOCUMENTS: 'Загрузите документы',
  PERSONS_DOCUMENTS: 'Документы клиента',
};

// eslint-disable-next-line max-len
export const FILES_DESCRIPTION = `Допустимые форматы файлов ${SUPPORTED_FORMATS}, объём - до ${MAX_MEGABYTE} мб.`;
